import {Component, inject, OnDestroy} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ButtonModule} from 'primeng/button';
import {DividerModule} from 'primeng/divider';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  templateUrl: './document-preview-dialog.component.html',
  imports: [ButtonModule, DividerModule, TranslocoPipe],
})
export class DocumentPreviewDialogComponent implements OnDestroy {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly config = inject(DynamicDialogConfig);
  private readonly ref = inject(DynamicDialogRef);

  private readonly blobUrl = window.URL.createObjectURL(this.config.data.blob);

  readonly safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);

  ngOnDestroy(): void {
    window.URL.revokeObjectURL(this.blobUrl);
  }

  onCloseDialog(): void {
    this.ref.close();
  }
}
